module.exports = __webpack_public_path__ + "static/img/user1.54d40531.png";